import type { CompanyTree } from "@rakazo/contracts";

type Company = CompanyTree[number];

/** The original company area keeps its existing storage and authorization boundary. */
export function isCompanyArea(company: Pick<Company, "id">, departmentId: string): boolean {
  return company.id === `company:${departmentId}`;
}

export function namedDepartments(company: Company): Company["departments"] {
  return company.departments.filter((department) => !isCompanyArea(company, department.id));
}

export function companyDepartmentLabel(company: Company, departmentId: string): string {
  return isCompanyArea(company, departmentId)
    ? "Company"
    : (company.departments.find((department) => department.id === departmentId)?.name ?? "");
}

export function companyAreaName(companies: CompanyTree, spaceId: string, fallback: string): string {
  const company = companies.find((candidate) =>
    candidate.departments.some((department) => department.id === spaceId),
  );
  return company && isCompanyArea(company, spaceId) ? company.name : fallback;
}
